(function ($) {
  $(document).ready(function () {
    $(document).on('click', '.js-stories-banner__btn', function(e) {
        e.preventDefault();
        e.stopPropagation();

        const block = $(this).closest('.stories-banner');
        const popup = $(block).find('.stories-banner__popup');

        window.removeScroll(true);
        $(popup).addClass('m-show');
        setTimeout(function() {
            $(popup).addClass('m-show-form');
        },100);
    });

    $(document).on('click', '.stories-banner__popup__bg, .stories-banner__popup__close', function() {
        const block = $(this).closest('.stories-banner');
        const popup = $(block).find('.stories-banner__popup');

        
        $(popup).removeClass('m-show-form');
        setTimeout(function() {
            $(popup).removeClass('m-show');
        },300);
         window.removeScroll(false);
    });
  });
})(jQuery);
